import {SizeCharts_MeasurementHints} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_charts.types';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  ProductImage,
  tabletAndUp,
  Text,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

export const MeasurementHints: FC<{
  measurementHints: SizeCharts_MeasurementHints | undefined;
}> = ({measurementHints}) => {
  if (!measurementHints) return null;

  return (
    <>
      <Text weight="w500" size="px16" data-testid="measurementHints-title">
        {measurementHints.headline}
      </Text>
      <InfoWrapper>
        <HintImage
          src={measurementHints.image.url}
          alt={measurementHints.image.description}
          importance="low"
          loading="lazy"
          padded
          dataTestId="measurementHints-hintImage"
        />
        <InstructionsWrapper data-testid="measurementHints-instructions">
          {measurementHints.instructionPoints.map((instruction, index) => (
            <Instruction key={`instruction-${index}`}>
              <InstructionTitle
                weight="w500"
                instructionNumber={index + 1}
                data-testid={`measurementHints-instruction-headline-${index}`}
              >
                {instruction.headline}
              </InstructionTitle>
              <InstructionText
                data-testid={`measurementHints-instruction-description-${index}`}
              >
                {instruction.instruction}
              </InstructionText>
            </Instruction>
          ))}
        </InstructionsWrapper>
      </InfoWrapper>
    </>
  );
};

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  ${tabletAndUp(
    css`
      flex-direction: row;
    `,
  )}
`;

const InstructionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Instruction = styled.div`
  margin-bottom: 1rem;
  padding-left: 2rem;

  ${tabletAndUp(css`
    padding-left: 3rem;
  `)}

  &:last-child {
    margin-bottom: 0;
  }
`;

const InstructionTitle = styled(Text)<{instructionNumber: number}>`
  position: relative;

  &:before {
    border: 1px solid ${COLORS.Grey1};
    border-radius: 50%;
    bottom: 0;
    color: ${COLORS.Black};
    content: '${({instructionNumber}) => instructionNumber}';
    left: -2rem;
    line-height: 1.5;
    height: 1.2rem;
    font-size: ${FONT_SIZES.px10};
    font-weight: ${FONT_WEIGHTS.w500};
    margin: auto;
    position: absolute;
    text-align: center;
    top: 0;
    width: 1.2rem;

    ${tabletAndUp(css`
      left: -1.6rem;
    `)}
  }
`;

const InstructionText = styled(Text)`
  display: block;
  line-height: 1.43;
  margin-top: 5px;
`;

const HintImage = styled(ProductImage)`
  background-color: ${COLORS.White};

  ${tabletAndUp(css`
    padding-top: 53%;
  `)}
`;
